export default {
  title: 'タイトル',
  content: '内容',
};
